module.exports = __webpack_public_path__ + "static/media/heroku.47a4a469.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/heroku.png
// module id = 119
// module chunks = 0